
import WaterComponent from "../../components/watersupplu/WaterMainComp"

export const WaterSupplyPage = ({ title_1, title_2, title }) => {
   
    return <div>
        <WaterComponent title_1={title_1} title_2={title_2} title={title} />
    </div>
}